export const environment = {
    production: false,
    version: '2026.08.07.0930 - PROD',
    cancelamento: `${window.location.origin}/api20/scheduleExternal`,
    baseURL: `${window.location.origin}/api/rest/`,
    baseURLScot20: `${window.location.origin}/api20/`
};
